import type { DominioValor } from '../../../domain/value-objects/Dominio';
import type { EstadoSensorValor } from '../../../domain/value-objects/EstadoSensor';
import type { NombreIcono } from '../ui/iconos';

/**
 * Traducción de conceptos del dominio a iconos.
 *
 * Vive en la capa de presentación a propósito: el dominio decide qué es una
 * alarma crítica, no con qué dibujo se representa.
 */

export const ICONO_DOMINIO: Readonly<Record<DominioValor, NombreIcono>> = {
  seguridad: 'escudo',
  activos: 'inventario',
  servicios: 'energia',
  sin_categoria: 'categoria',
};

export const ICONO_ESTADO_SENSOR: Readonly<Record<EstadoSensorValor, NombreIcono>> = {
  normal: 'exitoContorno',
  alarma: 'advertencia',
  // El nodo callado se dibuja como lo que es —falta de señal—, no como una
  // advertencia más: el problema no está en el valor, está en que no llega.
  sin_latido: 'sinWifi',
  sin_datos: 'infoContorno',
};
